import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  return (
    <section className={`py-20 bg-gradient-to-br from-primary via-accent to-secondary ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-background/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-background" variant="solid" />
            <span className="text-sm font-semibold text-background">Start Your Regulatory Journey Today</span>
          </div>

          <h2 className="font-heading font-bold text-4xl md:text-5xl text-background mb-6 leading-tight">
            Ready to Navigate Global Regulatory Challenges?
          </h2>

          <p className="text-lg md:text-xl text-background/90 mb-8 leading-relaxed">
            Partner with regulatory experts who understand your challenges and deliver proven results. Schedule a free consultation to discuss your specific needs and discover how we can accelerate your market entry.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button className="w-full sm:w-auto px-8 py-4 bg-background text-primary font-cta font-semibold text-base rounded-md hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 flex items-center justify-center space-x-2">
              <Icon name="CalendarIcon" size={20} />
              <span>Schedule Free Consultation</span>
            </button>
            <button className="w-full sm:w-auto px-8 py-4 bg-transparent text-background font-semibold text-base rounded-md border-2 border-background hover:bg-background hover:text-primary transition-all duration-300 flex items-center justify-center space-x-2">
              <Icon name="PhoneIcon" size={20} />
              <span>Call +91 9779962423</span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background/10 backdrop-blur-sm border border-background/20 rounded-lg p-6">
              <Icon name="ClockIcon" size={32} className="text-background mx-auto mb-3" variant="solid" />
              <div className="font-heading font-bold text-2xl text-background mb-1">24 Hours</div>
              <div className="text-sm text-background/80">Response Time</div>
            </div>
            <div className="bg-background/10 backdrop-blur-sm border border-background/20 rounded-lg p-6">
              <Icon name="CheckBadgeIcon" size={32} className="text-background mx-auto mb-3" variant="solid" />
              <div className="font-heading font-bold text-2xl text-background mb-1">98%</div>
              <div className="text-sm text-background/80">Success Rate</div>
            </div>
            <div className="bg-background/10 backdrop-blur-sm border border-background/20 rounded-lg p-6">
              <Icon name="UserGroupIcon" size={32} className="text-background mx-auto mb-3" variant="solid" />
              <div className="font-heading font-bold text-2xl text-background mb-1">500+</div>
              <div className="text-sm text-background/80">Satisfied Clients</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;